<!-- ----------------------------------------------- -->
<template>
  <nav id="pcHeader" class="primary">
    <v-row class="pc-app-bar-frame mx-0">
      <img class="title-pic" :src="getTitleImg" style="cursor: pointer;" />
      <v-spacer></v-spacer>
      <span class="pr-8 obs-title" v-show="selectedTm">{{ getTitle() }}</span>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 印刷用ヘッダ
 * PrintHeader.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";

export default {
  /** タグ名 */
  name: "kwb-print-header",
  mixins: [mixin],
  data() {
    return {
      drawer: null,
      showGuide: false,
      title: "",
      values: "【観測値一覧",
      past: "【過去一週間",
      rain: "(雨量)】",
      bsn: "(流域平均雨量)】",
      snow: "(積雪)】",
      stg: "(水位観測)】",
      qwtr: "(水質)】",
      dam: "(ダム)】",
      coast: "(海岸)】",
      rdbsn: "(レーダ流域)】",
      swstg: "(" + this.$store.state.app.config.replaceNameConfig.swstg + ")】",
    };
  },
  computed: {
    /** タイトル画像のPath */
    getTitleImg: {
      get() {
        let titlePath = "/kawabou/img/apptitle_gen.png";
        if (global.KWB_MODE === "admin") {
          titlePath = "/kawabou/img/apptitle_adm.png";
        }
        return titlePath;
      },
    },
    /**
     * 観測所種別コード取得
     */
    itmkndCd: {
      get() {
        return this.$route.query.itmkndCd;
      },
    },
    /** 表示種別(values:観測値一覧,past:過去観測所) */
    type: {
      get() {
        return this.$route.query.type;
      },
    },
    /** 通常水位情報取得 */
    selectedTm: {
      get() {
        if (this.itmkndCd === "300") {
          return this.$store.state.Swin.selectedSw;
        }
        return this.$store.state.Telemeter.selectedTm;
      },
    },
  },
  methods: {
    getTitle() {
      let title = "";
      let type = this.type === "values" ? this.values : this.past;
      if (this.itmkndCd === "1" && this.selectedTm.tmRainDetailInfo) {
        // 雨量
        title =
          type +
          this.rain +
          this.selectedTm.tmRainDetailInfo.obsNm +
          " " +
          this.selectedTm.tmRainDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmRainDetailInfo.rvrNm;
      } else if (this.itmkndCd === "2" && this.selectedTm.tmBsnDetailInfo) {
        // 流域平均雨量
        title =
          type +
          this.bsn +
          this.selectedTm.tmBsnDetailInfo.obsNm +
          " " +
          this.selectedTm.tmBsnDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmBsnDetailInfo.rvrNm;
      } else if (this.itmkndCd === "3" && this.selectedTm.tmSnwDetailInfo) {
        // 積雪
        title =
          type +
          this.snow +
          this.selectedTm.tmSnwDetailInfo.obsNm +
          " " +
          this.selectedTm.tmSnwDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmSnwDetailInfo.rvrNm;
      } else if (this.itmkndCd === "4" && this.selectedTm.tmStgDetailInfo) {
        // 通常水位
        title =
          type +
          this.stg +
          this.selectedTm.tmStgDetailInfo.obsNm +
          " " +
          this.selectedTm.tmStgDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmStgDetailInfo.rvrNm;
      } else if (this.itmkndCd === "6" && this.selectedTm.tmQwtrDetailInfo) {
        // 水質
        title =
          type +
          this.qwtr +
          this.selectedTm.tmQwtrDetailInfo.obsNm +
          " " +
          this.selectedTm.tmQwtrDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmQwtrDetailInfo.rvrNm;
      } else if (this.itmkndCd === "7" && this.selectedTm.tmDamDetailInfo) {
        // ダム諸量
        title =
          type +
          this.dam +
          this.selectedTm.tmDamDetailInfo.obsNm +
          " " +
          this.selectedTm.tmDamDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmDamDetailInfo.rvrNm;
      } else if (this.itmkndCd === "12" && this.selectedTm.tmCoastDetailInfo) {
        // 海岸
        title =
          type +
          this.coast +
          this.selectedTm.tmCoastDetailInfo.obsNm +
          " " +
          this.selectedTm.tmCoastDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmCoastDetailInfo.rvrNm;
      } else if (
        (this.itmkndCd === "20" && this.selectedTm.tmRdBsnDetailInfo) ||
        (this.itmkndCd === "21" && this.selectedTm.tmRdBsnDetailInfo)
      ) {
        // レーダ流域
        title =
          type +
          this.rdbsn +
          this.selectedTm.tmRdBsnDetailInfo.obsNm +
          " " +
          this.selectedTm.tmRdBsnDetailInfo.rsysNm +
          "水系 " +
          this.selectedTm.tmRdBsnDetailInfo.rvrNm;
      } else if (this.itmkndCd === "300" && this.selectedTm.mtSwobs) {
        // 危機管理水位
        title =
          type +
          this.swstg +
          this.selectedTm.mtSwobs.obsInfo.swobsNm +
          " " +
          this.selectedTm.mtSwobs.obsInfo.swrsysNm +
          "水系 " +
          this.selectedTm.mtSwobs.obsInfo.swrvrNm;
      }

      return title;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#pcHeader {
  display: block;
  min-width: 500px;
  height: 48px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  z-index: 3500;
  .obs-title {
    font-size: 0.825em;
  }
}
.pc-app-bar-frame {
  align-items: center;
  height: 100%;
  color: #fff;

  img {
    height: 100%;
  }
}
</style>
